import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WORDING_FILES } from '../../common/constants/defines';

import { ConfigLoaderService } from '../services/config-loader.service';
/** CustomTranslateLoader */
export class CustomTranslateLoader extends TranslateHttpLoader {
    private customHttp;
    private config;
    /**
     *
     * @param http
     * @param configLoaderService
     * @param prefix
     * @param suffix
     */
    public constructor (http: HttpClient, configLoaderService: ConfigLoaderService, prefix?: string, suffix?: string) {
        super(http, prefix, suffix);
        this.customHttp = http;
        this.config = configLoaderService;
    }
/** getTranslation */
    public getTranslation (lang?: string) {
        if (lang === WORDING_FILES.defaultWording) {
            return this.config.getDefaultGermanWordingFile();
        } else if (lang === WORDING_FILES.deWording) {
            return this.config.getDeWordingFile();
        }
    }

}
